class MapMarkerAnimationBottomRight {
    constructor( marker ) {
        this.render( marker );
        return this;
    }

    show ( delay ) {
        if( !delay ){ delay = 0; }

        TweenMax.set( this.marker.element, { opacity: 1 } );
        TweenMax.set( this.marker.square, { opacity: 0 } );
        TweenMax.set( this.marker.pin, { opacity: 0 } );
        TweenMax.set( this.marker.line1, { opacity: 0 } );
        TweenMax.set( this.marker.line2, { opacity: 0 } );
        //TweenMax.set( this.marker.text, { opacity: 0 } );
        
        TweenMax.set( this.marker.pin, { opacity: 1, ease: Cubic.easeOut } );
    
        TweenMax.fromTo( this.marker.circle1, 0.6, { scale: 0 }, { scale: 1, ease: Cubic.easeOut, delay: delay + 0.0 } );
        TweenMax.fromTo( this.marker.circle2, 0.6, { scale: 0 }, { scale: 1, ease: Cubic.easeOut, delay: delay + 0.2 } );
    }

    hide ( delay ) {
        if( !delay ){ delay = 0; }

        TweenMax.killTweensOf( [this.marker.element, this.marker.square, this.marker.pin, this.marker.line1, this.marker.line2, this.marker.text] );

        TweenMax.to( this.marker.text, 0.4, { opacity: 0, ease: Cubic.easeOut, delay: delay + 0 } );
        TweenMax.to( this.marker.pin, 0.8, { y: 0, x: 0, ease: Cubic.easeInOut, delay: delay + 0.4 } );

        TweenMax.to( this.marker.circle2, 0.4, { scale: 0, ease: Cubic.easeIn, delay: delay + 0.4 } );
        TweenMax.to( this.marker.circle1, 0.4, { scale: 0, ease: Cubic.easeIn, delay: delay + 0.6 } );
    }

    render ( marker ) {
        this.marker = marker;
        this.height = 300;
    }
}

export default MapMarkerAnimationBottomRight;